/* eslint-disable max-len */
import React from 'react'
import ThreeDotsLoader from '../../Components/LoadingDots';

export default function DeleteModal({
    setloading,
    setmodalType,
    type,
    selectedWishlist,
    loading,
    selectedProduct,
    name,
    removeParticular,
    removeAll,
    handleCrud
}) {
    const handleButtonTitle=()=>{
        let title=''
        if(type!=='remove' &&  type!=='removeAll'){
            title=`Delete Wishlist`
        }else{
            title='Yes, remove';
        }
        return title
    } 
    const handleFunction = ()=>{
        if(type!=='remove' &&  type!=='removeAll'){
            handleCrud(name,type);
        }else if(type==='remove'){
            removeParticular();
        }else{
            removeAll()
        }
    }
    return (
        <>
            <div className="modal-body relative sm:px-9 px-3 sm:pt-1 pt-0 sm:pb-6 pb-4 text-center">
                {type==='delete'?(
                    <p className="text-xs6 font-normal text-[#555259]">
                        Are you sure you want to delete <span className="font-semibold">{selectedWishlist.collection_name} </span>
                        along with all the products?
                    </p>
                ):(
                    <>{type==='remove'?(<p className="text-xs6 font-normal text-[#555259]">
                        Are you sure you want to delete <span className="font-semibold">{selectedProduct?.MODEL_DESCRIPTION || `${selectedProduct?.DESCRIPTION.length > 20 ? `${selectedProduct.DESCRIPTION.slice(0,20)}...`:`${selectedProduct.DESCRIPTION}`}`} </span>?
                    </p>):(
                        <p className="text-xs6 font-normal text-[#555259]">
                            Are you sure you want to remove all products from the wishlist?
                        </p>
                    )}</>
                )}
            </div>
            <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly sm:pb-5 pb-4 rounded-b-md">
                <button 
                    onClick={()=>{
                        setloading(true)
                        handleFunction()
                        setTimeout(() => {
                            setmodalType('');
                            setloading(false)
                        }, 2000);
                    }}
                    type="button"className="border border-[#555259] bg-[#ffffff] sm:text-xs6 text-sm font-normal text-[#555259] sm:py-3 py-2 sm:px-6 px-4 rounded-lg delete-wishlist" data-bs-dismiss="modal" aria-label="Close">
                    <>{loading?<ThreeDotsLoader color={"black"}/>:<>{handleButtonTitle()}</>}</>

                </button>
                <button 
                    onClick={()=>setmodalType('')}
                    type="button"
                    className="bg-[#555259] font-normal text-[#ffffff] sm:text-xs6 text-sm sm:py-3 py-2 sm:px-12 px-9 rounded-lg" data-bs-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
            </div>
        </>
    )
}
